import React from "react";
import { LockKeyhole, Mail, MessageCircle, ShieldAlert } from "lucide-react";
import { KD9LogoCircle, KD9Watermark } from "@/components/KD9Logo";
import { useAuth } from "@/context/AuthContext";

const BlockedAccount = () => {
  const { blockedMessage } = useAuth();
  const message = encodeURIComponent("Hola, mi cuenta KD9 aparece bloqueada. Solicito revisión y ayuda para recuperar el acceso.");

  return (
    <main
      className="min-h-screen relative overflow-hidden flex items-center justify-center px-5 py-12"
      style={{ background: "var(--kd9-bg)" }}
      data-testid="blocked-account-page"
    >
      <KD9Watermark size={720} opacity={0.05} className="absolute -right-48 -bottom-40" />
      <section className="relative z-10 w-full max-w-xl kd9-card p-7 sm:p-10 text-center">
        <div className="mx-auto mb-5 relative w-28 h-28 flex items-center justify-center">
          <KD9LogoCircle size={112} glow={false} />
          <div
            className="absolute -right-1 -bottom-1 w-11 h-11 rounded-full flex items-center justify-center"
            style={{ background: "#7A0E17", border: "3px solid var(--kd9-bg-2)" }}
          >
            <LockKeyhole size={21} color="#fff" />
          </div>
        </div>

        <div className="inline-flex items-center gap-2 font-mont text-[10px] tracking-[0.3em] uppercase mb-3" style={{ color: "#FCA5A5" }}>
          <ShieldAlert size={14} /> Acceso restringido
        </div>
        <h1 className="font-cinzel text-3xl sm:text-4xl tracking-[0.12em] mb-4" style={{ color: "#FCA5A5" }}>
          CUENTA BLOQUEADA
        </h1>
        <p className="font-cormorant text-xl leading-relaxed mb-2" style={{ color: "var(--kd9-text)" }}>
          {blockedMessage || "Cuenta bloqueada. Comunícate con Soporte KD9."}
        </p>
        <p className="font-mont text-sm leading-relaxed mb-8" style={{ color: "var(--kd9-text-soft)" }}>
          Tu sesión y todos los permisos de la plataforma fueron desactivados. No podrás ingresar a ningún panel o función hasta que un Director KD9 reactive la cuenta.
        </p>

        <div className="grid sm:grid-cols-2 gap-3">
          <a
            href={`https://wa.me/573006040757?text=${message}`}
            target="_blank"
            rel="noreferrer"
            className="kd9-btn-primary px-5 py-3 rounded-xl text-xs flex items-center justify-center gap-2"
            data-testid="blocked-support-whatsapp"
          >
            <MessageCircle size={16} /> WhatsApp Soporte
          </a>
          <a
            href="mailto:khaosdelta9@gmail.com?subject=Revisi%C3%B3n%20de%20cuenta%20bloqueada%20KD9"
            className="kd9-btn-outline px-5 py-3 rounded-xl text-xs flex items-center justify-center gap-2"
            data-testid="blocked-support-email"
          >
            <Mail size={16} /> Correo Soporte
          </a>
        </div>
      </section>
    </main>
  );
};

export default BlockedAccount;
